export enum MissingFilingReason {
	NotActive = 'NotActive',
	NoFiling = 'NoFiling',
	PendingEdits = 'PendingEdits',
	NoActivity = 'NoActivity',
	DueLater = 'DueLater',
	TooEarlyOSPI = 'TooEarlyOSPI',
}

export const missingFilingReasonLookup: Array<{text: string, textSentenceCase: string, value: keyof typeof MissingFilingReason}> = [
	{text: 'Not Active', textSentenceCase: 'Not active', value: MissingFilingReason.NotActive},
	{text: 'No Filing', textSentenceCase: 'No filing', value: MissingFilingReason.NoFiling},
	{text: 'Pending Revisions',textSentenceCase: 'Pending revisions', value: MissingFilingReason.PendingEdits},
	{text: 'No Activity', textSentenceCase: 'No activity', value: MissingFilingReason.NoActivity},
	{text: 'Due Later', textSentenceCase: 'Due later', value: MissingFilingReason.DueLater},
	{text: 'N/A Before 2020', textSentenceCase: 'N/A before 2020', value: MissingFilingReason.TooEarlyOSPI},
];
